export default "__VITE_ASSET__BWDzwoTN__"